import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { TabNav } from '../../components/nav/tabNav'
import Layout from '../../layout'
import Categories from './Categories'
import ProductsPage from './ProductsPage'
import Tags from './Tags'
import Variants from './Variants'

const pageTabs = [
  { name: 'Products', id: 'Products' },
  { name: 'Categories', id: 'Categories' },
  { name: 'Tags', id: 'Tags' },
  { name: 'Variants', id: 'Variants' },
]
export const Products = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const [activeTab, setActiveTab] = useState<string>(
    searchParams.get('tab') ?? pageTabs[0].id,
  )

  return (
    <Layout>
      <TabNav
        activeTab={activeTab}
        setActiveTab={(tab) => {
          setActiveTab(tab)
          setSearchParams({
            tab: tab,
          })
        }}
        tabs={pageTabs}
        className="mb-10"
      />

      {activeTab === 'Products' && <ProductsPage />}
      {activeTab === 'Categories' && <Categories />}
      {activeTab === 'Tags' && <Tags />}
      {activeTab === 'Variants' && <Variants />}
    </Layout>
  )
}
